import { setDateRange } from './helpers';

export const setDates = setDateRange('dates');
